import { metaAccount } from '@/router/meta-config'
const permissionKey = 'KIOSK'

export default [
  // Stands
  {
    path: '/kiosk-devices',
    name: 'page-kiosk-devices',
    component: () => import('@/pages/kiosk-devices'),
    meta: {
      ...metaAccount,
      permissionKey
    }
  },
  {
    path: '/kiosk-device/new',
    name: 'page-kiosk-device-new',
    component: () => import('@/pages/kiosk-device'),
    meta: {
      ...metaAccount,
      permissionKey
    }
  },
  {
    path: '/kiosk-device/:id',
    name: 'page-kiosk-device',
    component: () => import('@/pages/kiosk-device'),
    props: (route) => ({ id: route.params.id }),
    meta: {
      ...metaAccount,
      permissionKey
    }
  }
]
